export default __webpack_public_path__ + "static/media/basketball.756848b0.webp";